// inspired on https://hackernoon.com/10-react-mini-patterns-c1da92f068c5 (#8)

function numberToPrice(value, options = {}) {
  const showDecimals = options.showDecimals !== false;

  return value.toLocaleString("co", {
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0
  });
}

function formatPhoneNumber(value) {
  return value.replace("00", "+");
}

export default { numberToPrice, formatPhoneNumber };



// WEBPACK FOOTER //
// ./src/Formatters/Formatters.js